module.exports = __webpack_public_path__ + "img/img4.e211223f.jpg";